/**
 * AI Token Constants for Frontend
 * 
 * These constants match the backend aiTokenService values
 * Used for displaying initial credits and estimated costs
 */

// Initial credits for new users/businesses
export const AI_INITIAL_CREDITS_COUPLE = 200;
export const AI_INITIAL_CREDITS_SUPPLIER = 500;

/**
 * Get estimated cost for common AI operations
 * These are rough estimates for display purposes
 * Matches backend aiTokenService.getEstimatedCost structure
 * @param {'chat' | 'message' | 'task' | 'suggestion'} type - Type of AI operation
 * @returns {{credits: number, promptTokens: number, completionTokens: number, description: string, costGBP?: number}}
 */
export function getEstimatedCost(type) {
  // Support 'chat' as alias for 'message' to match frontend usage
  const messageType = type === 'chat' ? 'message' : type;
  
  if (messageType === 'message') {
    // Typical message: ~50 input tokens, ~100 output tokens
    return {
      credits: 0.2, // Average ~0.1-0.3 credits
      promptTokens: 50,
      completionTokens: 100,
      description: 'A simple question or conversation message',
      costGBP: 0.002 // Rough estimate
    };
  } else if (messageType === 'task') {
    // Task with function call: ~200 input tokens, ~150 output tokens, plus function execution
    return {
      credits: 1.0, // Average ~0.5-1.5 credits (includes function calls)
      promptTokens: 200,
      completionTokens: 150,
      description: 'A task that may include function calls (e.g., adding guests, creating todos)',
      costGBP: 0.01 // Rough estimate
    };
  } else if (messageType === 'suggestion') {
    // Generating suggestions might be lighter
    return {
      credits: 0.15,
      promptTokens: 30,
      completionTokens: 30,
      description: 'Generating suggestions',
      costGBP: 0.0015
    };
  }
  
  // Default fallback
  return {
    credits: 0.2,
    promptTokens: 50,
    completionTokens: 100,
    description: 'Standard message',
    costGBP: 0.002
  };
}

